module.exports = __webpack_public_path__ + "static/media/ic_auth_facebook.132742f0.svg";